import { render, staticRenderFns } from "./AlgoliaList.vue?vue&type=template&id=58340fbc&scoped=true"
import script from "./AlgoliaList.vue?vue&type=script&lang=js"
export * from "./AlgoliaList.vue?vue&type=script&lang=js"
import style0 from "./AlgoliaList.vue?vue&type=style&index=0&id=58340fbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58340fbc",
  null
  
)

export default component.exports